/**
 * Creates the base action buttons (edit, download, delete) for dashboard widgets
 * This function eliminates code duplication and ensures consistency across all widgets
 *
 * @param {Object} params - Parameters for creating action buttons
 * @param {Function} params.handleEdit - Handler for edit action
 * @param {Function} params.handleDelete - Handler for delete action
 * @param {Function} params.handleDownload - Handler for download action
 * @param {boolean} params.downloading - Whether any download is in progress
 * @param {Object} params.allowedRoles - Object with UPDATE and DELETE role arrays
 * @param {string} [params.divId] - Division owning the board; scopes the role check
 * @param {string} params.iconSize - Size of icons (default: 'sm')
 * @returns {Array} Array of action button objects
 */
export const createBaseActionButtons = ({
  handleEdit,
  handleDelete,
  handleDownload,
  downloading = false,
  allowedRoles = {},
  divId,
  iconSize = 'sm',
}) => {
  return [
    {
      iconName: 'edit',
      action: handleEdit,
      type: 'secondary',
      allowedRole: allowedRoles.UPDATE || [],
      divId,
      iconSize,
    },
    {
      iconName: 'download',
      action: handleDownload,
      type: 'secondary',
      iconSize,
      disabled: downloading,
    },
    {
      iconName: 'delete',
      action: handleDelete,
      type: 'danger',
      allowedRole: allowedRoles.DELETE || [],
      divId,
      iconSize,
    },
  ];
};

